<template>
  <div v-if="isAuthenticated === true">

  <div class="whole q-pt-xl">
    <div class="main-parent q-pt-lg ">

      <div class="row ">
      
      <div class="col-lg-3 q-mr-xl" id="firsttab">
      <q-card>
      <q-tabs
        v-model="tab"
        no-caps
          class="firsttab text-nonactive"
          active-color="firsttabactive"
          indicator-color="yellow"
          narrow-indicator
       
      >

         <q-tab name="daily" style="margin-left:15px " @click="visible=false" >Daily Analysis</q-tab>
        <q-tab name="weekly" style="margin-left:10px " @click="visible=false">Weekly Analysis</q-tab>
        
        </q-tabs>

       
     
      </q-card>
        </div> 
      
      
     
      
       
 <div class=" col q-pt-sm q-pl-lg pl-5 q-mx-xl"  style="max-width:225px;">
    <q-input dense outlined class="date" bg-color="white" color="icon" v-model="today_date" mask="date" :rules="['date']">
      <template v-slot:prepend>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
            <q-date v-model="today_date" :options="options">
              <div class="row items-center justify-end">
                <q-btn  v-close-popup label="Close" color="primary" flat />
              </div>
            </q-date>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
    
  </div>
   

          <div class="dpdn q-mt-sm  q-ml-lg "  style="color: black;max-width: 290px;overflow:hidden;display:flex;">
          
            <q-btn-dropdown class="col prdct" :label="product_label" style="color: black;font-size:11px;" >
        <q-list>
          <q-item
            clickable
            v-for="item in products"
            :key="item"
            v-close-popup
            @click="get_label(item)"
          >
            <q-item-section>
              <q-item-label>{{ item["product_name"] }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
       <q-tooltip anchor="bottom middle" self="top middle" >
                  {{ product_label}}
                  </q-tooltip>

            </div>
                <div class="col q-pt-sm  q-ml-xl">
                <q-btn  class="showanalysis q-ml-md" @click="get_analysis(analytic_detail)">Show Analysis</q-btn>
                </div>
      </div>
<div class="tabs">
<q-tab-panels v-model="tab" animated>  
      <q-tab-panel name="daily">

  <div id="q-app" >
  <div class="q-pa-md">
    <div class="q-gutter-y-md" style="max-width: 100%">
      <q-card  id="secondtab">
        <q-tabs
       
          v-model="tab1"
          id="second"
          class="secondtab "
          active-color="activecolor bg-blue-grey-2"
          indicator-color="transparent"
          align="justify"
          narrow-indicator
        >
        <div class="greencolor">
        </div>
         <q-tab name="rank" >Rank Details</q-tab>
          <q-tab name="toprank" >Top Ranked Products</q-tab>
          <q-tab name="price">Price Change Insights</q-tab>
          <q-tab name="aibased"> AI Based Price Prediction</q-tab>
        </q-tabs>
        <div class="rankdetails">
       <q-tab-panels v-model="tab1" animated>  
      <q-tab-panel name="rank">
        
         <div class="info">
      <div class="details">
        <q-table
          :loading="isLoading"
          ref="table"
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          hide-bottom
          :data="rows4"
          separator="none"
          :columns="columns4"
          row-key="category"
        >
          <template v-slot:header="props">
            <q-tr :props="props" >
              
              <q-th
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
                class="ranktab"
                :style="{ fontSize: '15px', color: 'white' }"
                
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
         
          <q-td
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
            style="background-color:white"
          >
            {{ col.value }}
          </q-td>

         
        </q-tr>
 
          </template>
        </q-table>
      </div>
    </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>

    <div >
       <q-tab-panels v-model="tab1" animated class="toprank">  
      <q-tab-panel name="toprank"  >
<!-- Top rank table title before loading data -->
        <div class=" q-gutter-sm table" v-if="toprank">
          <q-table
            :loading="isLoading"        
                      hide-bottom
                       style="background-color:white;"
                      :columns="seller"
            >
       <template v-slot:header="props">
                  <q-tr :props="props">
                    
                    <q-th
                      v-for="col in seller"
                      :key="col.name"
                      :props="props"
                      class="ranktab"
                      :style="{ fontSize: '15px', color: 'white', }"
                     
                    >
                      {{ col.label }}
                    </q-th>
                  </q-tr>
                </template>
            </q-table>
      
    </div>
    <!--  -->
    <div class="info" >
      <div class="details" >
        <q-table
          :loading="isLoading"
          ref="table"
         
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          hide-bottom
          :data="rows5"
         
          :columns="tbl"
          row-key="category"
          
        >
          <template v-slot:header="props" >
            <q-tr :props="props" style="display: none;"  >
              <q-th ><p style="display: none;" ></p></q-th>
             
            </q-tr>
          </template>
          <template v-slot:body="props">
            
              <q-tr  :props="props">
                
               
               
                <div class="q-pa-md">
                   <p style="padding:0px 20px 0px 20px; margin:15px auto 25px auto; font-size:16px; font-weight:600">
                {{"Category : "+props.row['category']}}
                </p>
                

                <q-table
                  :loading="isLoading"
                  style="background-color:white;max-width:71rem;"
                  :data="props.row['seller_details']"
                         
                  hide-bottom
                  
                  :columns="seller"
         
                >

                <template v-slot:header="props">
                  <q-tr :props="props">
                    
                    <q-th
                      v-for="col in seller"
                      :key="col.name"
                      :props="props"
                      class="ranktab"
                      :style="{ fontSize: '15px', color: 'white' }"
                      
                    >
                      {{ col.label }}
                    </q-th>
                  </q-tr>
                </template>

                <template v-slot:body="props">
                  
            
                  <q-tr
                   
                    :props="props"
                    style="background-color:white"
                  >
                    <q-td key="rank" :props="props">
                      {{ props.row['rank'] }}
                    </q-td>

                    <q-td style="text-align:left" key="name" :props="props">
                      {{
                        props.row['name']
                      }}
                    </q-td>
                    <q-td key="price" :props="props">
                      {{
                        "₹ "+ props.row['price']
                      }}
                    </q-td>
                    <q-td key="link" :props="props">
                      <a :href="props.row['link']" target="_blank"><q-btn class="openlink" >open link</q-btn></a>
                     <!-- <q-btn @submit.prevent="" @click="copyText(props.row['link']);" color="primary" >copy link</q-btn>-->
                    </q-td>
                    
                  </q-tr>
                </template>
                
                </q-table>
                </div>
               </q-tr>
                
            
         
        
       
       </template>
        </q-table>
      </div>
    </div>
           

      </q-tab-panel>
      </q-tab-panels>
    </div>
   <div class="rankdetails">
       <q-tab-panels v-model="tab1" animated>  
      <q-tab-panel name="price" class="priceinsight">
       
         
    <div class="info" >
      <div class="details" >
        <q-table
          :loading="isLoading"
          ref="table"
          
         
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          hide-bottom
          :data="rows6"
         separator="none"
          
          row-key="product_name"
          
        >
        <template v-slot:header="props" style="font-size:18px;display:none ;">
            <q-tr :props="props" style="font-size:18px;display:none ;">
              <q-th > <p style="font-size:18px;display:none ;" ></p></q-th>
             
            </q-tr>
          </template>

        <template v-slot:body="props">
          <div class=" q-px-md ">

            
               <q-table
               hide-bottom
               :data="rows6"
              

               >

                <template v-slot:header="props">
                  <q-tr :props="props" >
                    <q-th style="font-size:15px; text-align:left">{{"Product Name : " + rows6[0]['product_name']}}</q-th>
                    
                    
                  </q-tr>
                </template>

                <template v-slot:body="props">
                  
                  <q-tr :props="props"><p>{{ rows6[0]['text_insights']}}</p></q-tr>
                  <!-- <q-tr><q-btn class="priceinsightbutton" style="margin-left:20px;margin-bottom:10px"  @click="get_priceinsights_dashboard_id(analytic_detail)">{{visible?"Hide graph":"Show graph"}}</q-btn></q-tr> -->
                 
                  <!-- <q-tr style="text-align:center" > 
                   
                  
                      <iframe
                          width=98%
                          height="420px"
                          :src= "pricewatch_graph_url"
                          
                          v-if="visible"
                          >
                      </iframe>
                  
                    
                  </q-tr> -->
                 
                </template>

                
               </q-table>

          </div>
               
               
        </template>
                      
        </q-table>

        
      </div>
    

        </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>
    <div class="rankdetails">
       <q-tab-panels v-model="tab1" animated>  
      <q-tab-panel name="aibased">
         <div class="info">
      <diV class="details">
       <q-table
          :loading="isLoading"
          ref="table"
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          hide-bottom
          :data="rows6"
          row-key="product_name"
          
        >
        <template v-slot:header="props" style="display:none ;">
            <q-tr :props="props" style="display:none ;">
              
             
            </q-tr>
          </template>

        <template v-slot:body="props" >
          <div>
               <q-table
               hide-bottom
               :data="rows6"
                seperator="none"
               :columns="columns7"
              
                 class="my-sticky-header-table"
              style="background-color:white;"
              >

                <template v-slot:header="props">
                  <q-tr :props="props" >
                    <q-th
                      v-for="col in props.cols"
                      :key="col.name"
                      :props="props"
                      class="ranktab"
                      :style="{ fontSize: '15px', color: 'white' }"
                      
                    >
                      {{ col.label }}
                  </q-th>
                  </q-tr>
                </template>

                <template v-slot:body="props"  >
                
               
                  <q-tr  v-for="i in prediction_details['brand'].length" v-bind:key="i">
                    
                    <q-td   key="number" style="text-align:center">{{i }}</q-td>
                    <q-td key="brand" style="text-align:center">{{ prediction_details['brand'][i-1]}}</q-td>
                    <q-td key="recent_price" style="text-align:center">{{"₹ "+ prediction_details['recent_price'][i-1]}}</q-td>
                    <q-td key="selling_price" style="text-align:center">{{"₹ "+ prediction_details['Selling_Price'][i-1].toFixed(2)}}</q-td>
                   
                  </q-tr> 
                 
                 
                  
                </template>

                
               </q-table>

               <p style="font-weight:bold;font-size:16px;padding-top:25px ;">The rule set by you is as follows:</p>
             
                <div class="box" id="box">
                  <ul class="checkmark">
                  <li class="rule q-pr-sm">Your price should be <span class="productprice" style="font-weight:500;text-transform:uppercase;">{{user_request[0]['price_watch_details'][0]['comparision']}}</span> the <span  class="productprice" style="font-weight:500;text-transform:uppercase;">{{user_request[0]['price_watch_details'][0]['pricing']}}</span> competitor.</li>
                </ul>
                </div>
                
 

                  <p style="padding:28px 20px 0px 20px;font-size: 15px;">Today's price for your product <span  style="font-weight:500;color: #102689">{{daily_analysis[0]['product_name']}}</span> is <span style="font-weight:500;color: #102689;">{{prediction_details['recent_client_price']!=null?"₹ "+prediction_details['recent_client_price']: "not available due"}}</span>.  Smart price recommendation for tomorrow for your product is  <span style="font-weight:500;color: #102689">{{prediction_details['smart_price']==null || prediction_details['recent_client_price']==null?"Not Available due to insufficient data":"₹ "+prediction_details['smart_price']}}</span> .This recommendation is based on the above competitor price prediction and smart price rule set by the user which is displayed above.</p>
                  

          </div>
               
               
        </template>
                      
        </q-table>

      </diV>

    </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>
    

       
      </q-card>
    </div>
  </div>
</div>
   
      </q-tab-panel>
      </q-tab-panels>
      
     
        

      <q-tab-panels v-model="tab" animated>  
      <q-tab-panel name="weekly">
        <div
          class="row q-gutter-sm table"
          
          style="margin-left:1rem"
        >
        <p style="font-size:16px;font-weight:600;color: #102689;">Last updated on : {{date}}</p>
        
        </div>
        

<div id="q-app" >
  <div class="q-pa-md">
    <div class="q-gutter-y-md" style="max-width: 100%">
      <q-card  id="secondtab">
        <q-tabs
          v-model="tab2"
         
          class="secondtab"
          active-color="activecolor bg-blue-grey-2"
          indicator-color="transparent"
          align="justify"
          narrow-indicator
          id="second"
        >
        <div class="greencolor">

        </div>
         <q-tab name="outofstock" >Out of Stock Products</q-tab>
          <q-tab name="weeklyupdate" >Weekly Update</q-tab>
          <q-tab name="competitor" >Competitors Details</q-tab>
          <q-tab name="productmatching" >Product Matching</q-tab>
           <q-tab name="pricepunit" >Price Per Unit</q-tab>
        </q-tabs>

         <div class="rankdetails">
       <q-tab-panels v-model="tab2" animated>  
      <q-tab-panel name="outofstock">
        <div  v-if="noOutofStock == true" class="nooutofstock q-mt-lg q-mb-xl q-pb-xl" >
          <p>NO OUT OF STOCK</p>
            </div>
           
        
       
       
        <div  class="outofbox "  id="outofbox"    v-if="noOutofStock == false" >
        <q-table
          :loading="isLoading"
          ref="table"
        
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          class="outofstock"
          hide-bottom
          :data="rows9"
          :columns="columns9"
         
          
        >
          <template v-slot:header="props">
         
            <q-tr :props="props">
              
               <q-th
                v-for="col in columns9"
                :key="col.name"
                :props="props"
                class="header1"
                :style="{ fontSize: '15px', color: 'white' }"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          
          </template>
          
          <template  v-slot:body="props">
        
         
          
            
            <q-tr
              v-for="v in analysis[0]['competitors_details']['unavailable_product'].length"
              :key="v"
              :props="props"
              
              
            >
              <q-td key="title" :props="props" class="body1 " >
                {{ analysis[0]['competitors_details'][ 'unavailable_product' ][v-1 ] }}
               
                
              </q-td>
               
            </q-tr>
           
           <q-sperator></q-sperator>
          
          
          </template>
        </q-table> 
       
       </div>
       <div>
        <p style="color:#FF0000;font-weight:18px;font-weight:bold;float:left">* All the out of stock products are excluded from the calculation</p>
        </div>
 


     
        
      </q-tab-panel>
      </q-tab-panels>
   </div>
    
  
     <div class="rankdetails">

       <q-tab-panels v-model="tab2" animated> 
      <q-tab-panel name="weeklyupdate" >
        
      
     <div class=" q-gutter-sm tables">
             
      <div class="info" >
        
        <div class="details">
          <q-table
            :loading="isLoading"
            ref="table"
            v-model:pagination="pagination"
          :rows-per-page-options="[0]"
            hide-bottom
            :data="rows"
            separator="none"
            :columns="columns"
            virtual-scroll
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <!-- <q-th>
            
          </q-th> -->
           
                <q-th
                  v-for="col in columns"
                  :key="col.name"
                  :props="props"
                  class="ranktab"
                  :style="{ fontSize: '15px', color: 'white' }"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" style="background-color:white">
                <q-th>
                  <q-td key="title" :props="props">
                    Most Popular
                  </q-td>
                </q-th>
                <q-td key="product" :props="props">
                  {{ analysis[0]["most_popular"]["product_name"] }}
                </q-td>
                <q-td key="competitorsprice" :props="props">
                  {{
                    analysis[0]["most_popular"]["price_of_competitor"].toFixed(
                      2
                    )
                  }}
                </q-td>
                <q-td
                  key="pricegap"
                  :props="props"
                  :style="
                    analysis[0]['most_popular']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["most_popular"]["price_gap"].toFixed(2) }}
                  {{ analysis[0]["most_popular"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
                <q-td
                  key="pricedifference"
                  :props="props"
                  :style="
                    analysis[0]['most_popular']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["most_popular"]["price_%_change"]
                  }}{{
                    analysis[0]["most_popular"]["price_gap"] > 0 ? "⮝" : "⮟"
                  }}
                </q-td>
              </q-tr>
              <q-tr :props="props" style="background-color:#ffff">
                <q-th>
                  <q-td key="title" :props="props">
                    Costliest
                  </q-td>
                </q-th>
                <q-td key="product" :props="props">
                  {{ analysis[0]["costliest"]["product_name"] }}
                </q-td>
                <q-td key="competitorsprice" :props="props">
                  {{
                    analysis[0]["costliest"]["price_of_competitor"].toFixed(2)
                  }}
                </q-td>
                <q-td
                  key="pricegap"
                  :props="props"
                  :style="
                    analysis[0]['costliest']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["costliest"]["price_gap"].toFixed(2) }}
                  {{ analysis[0]["costliest"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
                <q-td
                  key="pricedifference"
                  :props="props"
                  :style="
                    analysis[0]['costliest']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["costliest"]["price_%_change"]
                  }}{{ analysis[0]["costliest"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
              </q-tr>
              <q-tr :props="props" style="background-color:#ffff">
                <q-th>
                  <q-td key="title" :props="props">
                    Cheapest
                  </q-td>
                </q-th>
                <q-td key="product" :props="props">
                  {{ analysis[0]["cheapest"]["product_name"] }}
                </q-td>
                <q-td key="competitorsprice" :props="props">
                  {{
                    analysis[0]["cheapest"]["price_of_competitor"].toFixed(2)
                  }}
                </q-td>
                <q-td
                  key="pricegap"
                  :props="props"
                  :style="
                    analysis[0]['cheapest']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["cheapest"]["price_gap"].toFixed(2) }}
                  {{ analysis[0]["cheapest"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
                <q-td
                  key="pricedifference"
                  :props="props"
                  :style="
                    analysis[0]['cheapest']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["cheapest"]["price_%_change"]
                  }}{{ analysis[0]["cheapest"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
                
              </q-tr>
              
              <q-tr :props="props" style="background-color:#ffff">
                <q-th>
                  <q-td key="title" :props="props">
                    Average
                  </q-td>
                </q-th>
                <q-td key="product" :props="props">
                  {{ analysis[0]["average"]["product_name"] }}
                </q-td>
                <q-td key="competitorsprice" :props="props">
                  {{ analysis[0]["average"]["price_of_competitor"].toFixed(2) }}
                </q-td>
                <q-td
                  key="pricegap"
                  :props="props"
                  :style="
                    analysis[0]['average']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["average"]["price_gap"].toFixed(2) }}
                  {{ analysis[0]["average"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                </q-td>
                <q-td
                  key="pricedifference"
                  :props="props"
                  :style="
                    analysis[0]['average']['price_gap'] >= 0
                      ? 'color:#51C519;brightness(2);font-weight:bold;'
                      : 'color:#FF0000;brightness(2);font-weight:bold;'
                  "
                >
                  {{ analysis[0]["average"]["price_%_change"]
                  }}{{ analysis[0]["average"]["price_gap"] > 0 ? "⮝" : "⮟" }}
                 
                </q-td>
                 
              </q-tr>
            
            </template>
  
          </q-table>
            
          <!-- <p class="notice">*Notification Services will send you analytic report periodically in your registered mail id, For more details of this service click here</p> -->
        </div>
          <div class="yourprice" style="margin-left:57rem;margin-top:0.5rem" v-if="expanded === true">
        <q-h4 class="side" style="font-size:16px">Your Price : </q-h4>
        <q-h4 class="answer" style="font-size:16px">{{
          analysis[0]["user_product_price"]
        }}</q-h4>
      </div>
      </div>

   
     
   
        </div>
       
     
      </q-tab-panel>
      </q-tab-panels>
    </div>
     <div class="rankdetails">
       <q-tab-panels v-model="tab2" animated>  
      <q-tab-panel name="competitor">
        <div>
          <div class=" q-gutter-sm table">
      
      
      <div style="margin-top:1.75rem;margin-bottom:1.75rem">
        <q-h4 class="side" style="font-size:17px;color:#102689;font-weight:bold">Product Name : </q-h4>
        <q-h4 class="answer" style="font-size:17px;color:#102689;font-weight:bold">{{ product_label }}</q-h4>
      </div>

      <div class="info" >
        <div class="details">
          <q-table
            :loading="isLoading"
            v-model:pagination="pagination"
          :rows-per-page-options="[0]"
            hide-bottom
             separator="none"
            :data="rows2"
            
            :columns="columns2"
          >
            <template v-slot:header="props">
              <q-tr :props="props" >
                <q-th
                  v-for="col in columns2"
                  :key="col.name"
                  :props="props"
                  class="ranktab"
                  :style="{ fontSize: '15px', color: 'white' }"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" style="background-color:#ffff">
                <q-td key="competitors" :props="props">
                  {{ props.row.competitor }}
                </q-td>
                <q-td key="price" :props="props">
                  {{ props.row.price_of_competitor.toFixed(2) }}
                </q-td>
                <q-td key="keywords_in_name" :props="props">
                  <q-btn
                    label="Show Key words"
                   flat
                   style="color:#09C434;font-weight:600;"
                    @click="props.row.keyword = !props.row.keyword"
                    
                  />
               
                  <q-dialog v-model="props.row.keyword">
                    <q-card>
                      <q-card-section>
                        <div class="text-h6">Keywords</div>
                      </q-card-section>

                      <q-card-section class="q-pt-none">
                        <p
                          v-for="item in props.row.keywords"
                          :key="item"
                          style="margin: 0; display: inline;"
                        >
                          {{ item + " " + "," + " " }}
                        </p>
                        <!-- <p style="margin: 0; display: inline;">{{analysis[0]['competitors_details']['competitors_dtls'][i-1]['keywords'][analysis[0]['competitors_details']['competitors_dtls'][i-1]['keywords'].length-1]}}</p> -->
                      </q-card-section>

                      <q-card-actions align="right">
                        <q-btn
                          flat
                          label="OK"
                          color="primary"
                          v-close-popup
                        ></q-btn>
                      </q-card-actions>
                    </q-card>
                  </q-dialog>
                </q-td>
                <q-td key="offers" :props="props">
                  <q-btn
                    label="Show offers"
                   flat
                   style="color:#09C434;font-weight:600;"
                    @click="props.row.offer = !props.row.offer"
                    
                  />
                
                  <q-dialog v-model="props.row.offer">
                    <q-card>
                      <q-card-section>
                        <div class="text-h6">Offers/Promotions</div>
                      </q-card-section>

                      <q-card-section class="q-pt-none">
                        <p
                          v-for="item in props.row.offers"
                          :key="item"
                          style="margin: 0; display: inline;"
                        >
                          {{ item + " " + "," + " " }}
                        </p>
                        <!-- <p style="margin: 0; display: inline;">{{analysis[0]['competitors_details']['competitors_dtls'][i-1]['offers'][analysis[0]['competitors_details']['competitors_dtls'][i-1]['offers'].length-1]}}</p> -->
                      </q-card-section>

                      <q-card-actions align="right">
                        <q-btn
                          flat
                          label="OK"
                          color="primary"
                          v-close-popup
                        ></q-btn>
                      </q-card-actions>
                    </q-card>
                  </q-dialog>
                  <!-- {{analysis[0]['competitors_details']['competitors_dtls'][0]['offers']}} -->
                </q-td>
                <q-td key="customer_review" :props="props">
                  <q-btn
                    label="Show Reviews"
                   flat
                   style="color:#09C434;font-weight:600;"
                   @click="props.row.review = !props.row.review"
                    
                  />
                 
                  <q-dialog v-model="props.row.review">
                    <q-card>
                      <q-card-section>
                        <div class="text-h6">Positive reviews keywords</div>
                      </q-card-section>

                      <q-card-section class="q-pt-none">
                        <p
                          v-for="item in props.row.positive_review"
                          :key="item"
                          style="margin: 0; display: inline;"
                        >
                          {{ item + " " + "," + " " }}
                        </p>
                        <!-- <p style="margin: 0; display: inline;">{{analysis[0]['competitors_details']['competitors_dtls'][i-1]['positive_review'][analysis[0]['competitors_details']['competitors_dtls'][i-1]['positive_review'].length-1]}}</p> -->
                      </q-card-section>

                      <q-card-actions align="right">
                        <q-btn
                          flat
                          label="OK"
                          color="primary"
                          v-close-popup
                        ></q-btn>
                      </q-card-actions>
                    </q-card>
                  </q-dialog>
                  <!-- {{analysis[0]['competitors_details']['competitors_dtls'][0]['positive_review']}} -->
                </q-td>
                <q-td key="customer_negative_review" :props="props">
                  <q-btn
                    label="Show Reviews"
                   flat
                   style="color:#FF0000;font-weight:600;"
                   @click=" props.row.negative_reviews = !props.row.negative_reviews"
                    
                  />
                 
                  <q-dialog v-model="props.row.negative_reviews">
                    <q-card>
                      <q-card-section>
                        <div class="text-h6">Negative Review keywords</div>
                      </q-card-section>

                      <q-card-section class="q-pt-none">
                        <p
                          v-for="item in props.row.negative_review"
                          :key="item"
                          style="margin: 0; display: inline;"
                        >
                          {{ item + " " + "," + " " }}
                        </p>
                        <p style="margin: 0; display: inline;">
                          {{ props.row.negative_review[0] }}
                        </p>
                      </q-card-section>

                      <q-card-actions align="right">
                        <q-btn
                          flat
                          label="OK"
                          color="primary"
                          v-close-popup
                        ></q-btn>
                      </q-card-actions>
                    </q-card>
                  </q-dialog>
                  <!-- {{analysis[0]['competitors_details']['competitors_dtls'][0]['positive_review']}} -->
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </div>
        </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>
     <div class="rankdetails">
       <q-tab-panels v-model="tab2" animated>  
      <q-tab-panel name="productmatching">
        <div>
           
    <div class="info" >
      <div class="details">
        <q-table
          :loading="isLoading"
          ref="table"
          virtual-scroll
    
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
          hide-bottom
          :data="rows3"
         separator="none"
          :columns="columns3"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <!-- <q-th>
            
          </q-th> -->
              <q-th
                v-for="col in columns3"
                :key="col.name"
                :props="props"
                class="ranktab"
                :style="{ fontSize: '15px', color: 'white' }"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr
              v-for="i in analysis[0]['percentage_match']['brands'].length"
              :key="i"
              :props="props"
              style="background-color:white"
            >
              <q-td key="title" :props="props">
                {{ analysis[0]["percentage_match"]["brands"][i - 1] }}
              </q-td>

              <q-td key="qualitymatched" :props="props">
                {{
                  analysis[0]["percentage_match"]["features_match"][i - 1] !==
                  "NA"
                    ? analysis[0]["percentage_match"]["features_match"][i - 1] +
                      "%"
                    : "NA"
                }}
              </q-td>
              <q-td key="productdetailsmatched" :props="props">
                {{
                  analysis[0]["percentage_match"]["ingrediant_match"][i - 1] !==
                  "NA"
                    ? analysis[0]["percentage_match"]["ingrediant_match"][
                        i - 1
                      ] + "%"
                    : "NA"
                }}
              </q-td>
              <q-td key="offers" :props="props">
                {{
                  analysis[0]["percentage_match"]["offer_match"][i - 1] !== "NA"
                    ? analysis[0]["percentage_match"]["offer_match"][i - 1] +
                      "%"
                    : "NA"
                }}
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
        </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>
          <div class="rankdetails">
       <q-tab-panels v-model="tab2" animated>  
      <q-tab-panel name="pricepunit">
        <div>
         

    <div class="info">
      <div class="details">
        <q-table
          :loading="isLoading"
          ref="table"
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
         
          hide-bottom
          :data="rows8"
          separator="none"
          :columns="columns8"
          row-key="product_name"
        >
          <template v-slot:header="props">
            <q-tr :props="props" >
              
              <q-th
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
                class="ranktab"
                :style="{ fontSize: '15px', color: 'white' }"
                
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
         
          <q-td
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
            style="background-color:#ffff"
          >
            {{ col.value }}
          </q-td>

         
        </q-tr>
 
          </template>
        </q-table>
      </div>
    </div>
        </div>

      </q-tab-panel>
      </q-tab-panels>
    </div>
       
      </q-card>
    </div>
  </div>
</div>
      </q-tab-panel>
      </q-tab-panels>


    </div>
   
   
   </div>  

  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      isAuthenticated: false,
      
      tab:'daily',
       tab1:'rank',
      tab2:'outofstock',
      date:'date',
      product_label: "Select Product",
      toprank:true,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      smartpriceinfo: false,
      isLoading: true,
      keyword: false,
      review: false,
      negative_reviews: false,
      YourPrice:false,
      expanded: false,
      expanded1: false,
      expanded2: false,
      expanded3: false,
      expanded4: false,
      expanded5: false,
      expanded6: false,
      expanded7: false,
      expanded8: false,
      rankings:'',
      today_date:'',
      temp_date:'',
      max_length:'',
      pricewatch_graph_url:'',
      unavailable_product: [],
      user_request:[],
      
      analysis: [],
      visible: false,
      daily_analysis:[],
      dash_board_id:'',
      date:'date',
      products: [],
      exp: false,
      analytic_detail: [],
      value: true,
      noOutofStock : false,
      notif: this.value ? "Notifications On" : "Notifications OFF",
      columns: [
        {
          name: "title",
          required: true,
          label: "Popularity",
          align: "left",
          field: "title",
        },
        {
          name: "product",
          required: true,
          label: "Product Name",
          align: "left",
          field: "product",
        },
        {
          name: "competitorsprice",
          align: "center",
          label: "Competitors Price",
          field: "competitorsprice",
        },
        { name: "pricegap", label: "Price Gap (Rs)", align: "center" },
        {
          name: "pricedifference",
          label: "Price Difference(%)",
          align: "center",
        },
      ],
      rows: [
        {
          product: "Frozen Yogurt",
          competitorsprice: 159,
          pricegap: 6.0,
          pricedifference: 24,
        },
      ],
      columns2: [
        {
          name: "competitors",
          label: "Competitors",
          field: "type",
          align: "left",
        },
        {
          name: "price",
          label: "Price",
          field: "price",
          align: "center",
        },
        {
          name: "keywords_in_name",
          label: "Keywords in Name",
          field: "keywords_in_name",
          align: "center",
        },
        {
          name: "offers",
          label: "Offers",
          field: "offers",
        },
        {
          name: "customer_review",
          label: "+ve Review Topics",
          field: "customer_review",
          align: "center",
        },
        {
          name: "customer_negative_review",
          label: "-ve Review Topics",
          field: "customer_negative_review",
          align: "center",
        },
      ],
      rows2: [
        // {
        // competitors:"hemanth",
        // price:14521,
        // keywords_in_name:"positive",
        // offers:"fullcashback",
        // customer_review:"excellent",
        // }
      ],
      columns3: [
        {
          name: "title",
          required: true,
          label: "Competitors",
          align: "center",
          field: "title",
        },
        // {
        //   name: "pricematched",
        //   required: true,
        //   label: "Price Matched",
        //   align: "left",
        //   field: "pricematched",
        // },
        {
          name: "qualitymatched",
          required: true,
          label: "Features Matched",
          align: "center",
          field: "qualitymatched",
        },
        {
          name: "productdetailsmatched",
          required: true,
          label: "Ingredients Matched",
          align: "center",
          field: "productdetailsmatched",
        },
        {
          name: "offers",
          required: true,
          label: "Offers/Promotions",
          align: "center",
          field: "offers",
        },
      ],
      rows3: [
        {
          title: "detailsarrivesoon",
          pricematched: "yes",
          quantitymatched: "50",
          productdetailsmatched: "50",
          offers: "50",
        },
      ],
      columns4: [
        /*
        {
          name: "category",
          required: true,
          label: "Category",
          align: "center",
          field: "category",
        },*/
        {
          name: "ranking",
          required: true,
          label: "Today's rank in Amazon",
          align: "center",
          field: "rank",
        },
        {
          name: "ranking_7_days",
          required: true,
          label: "Rank (7 days average)",
          align: "center",
          field: "rank7",
        },
        {
          name: "ranking_30_days",
          required: true,
          label: "Rank (30 days average)",
          align: "center",
          field: "rank30",
        },
        {
          name: "ranking_90_days",
          required: true,
          label: "Rank (90 days average)",
          align: "center",
          field: "rank90",
        },
      ],
      rows4: [
        {rank:'',
         rank7:'',
         rank30:'',
         rank90:''},
        {rank:'',
         rank7:'',
         rank30:'',
         rank90:''},
         
        {rank:'',
         rank7:'',
         rank30:'',
         rank90:''},
        {rank:'',
         rank7:'',
         rank30:'',
         rank90:''},
        
      ],
      columns5: [
        {
          name: "amazon_ranking",
          required: true,
          label: "Ranking in Amazon",
          align: "center",
          field: "rank",
        },
        {
          name: "product_name",
          required: true,
          label: "Product Name",
          align: "center",
          field: "product_name",
        },
      ],
      tbl:[
        {
          name: "Category",
          required: true,
          label: "",
          align: "center",
          field: "category",
        },
        {
          name: "seller_details",
          required: true,
          label: "",
          align: "center",
          field: "seller_details",
        },
      ],
      rows5: [
 
  
],
   
    
    seller:[
        {
          name: "rank",
          required: true,
          label: "Rank in Amazon",
          align: "center",
          field: "rank",
        },
        {
          name: "name",
          required: true,
          label: "Product Name",
          align: "center",
          field: "name",
        },
        {
          name: "price",
          required: true,
          label: "Price",
          align: "center",
          field: "price",
        },
        {
          name: "link",
          required: true,
          label: "Product Link",
          align: "center",
          field: "link",
        },
        
        ],
         columns6: [
           {
          name: "product_name",
          required: true,
          label: "Product Name",
          align: "center",
          field: "product_name",
        },
        {
          name: "text_insights",
          required: true,
          label: "Text Insights",
          align: "center",
          field: "text_insights",
        },
        
      ],
      rows6: [
        {
          product_name: "",
          text_insights: "",
        },],
       
       prediction_details:{
        "brand": [],
        "smart_price":'',
        "Selling_Price": []
      },
      columns7:[
        {
          name: "number",
          required: true,
          label: "Serial No",
          align: "center",
          field: "number",
        },
        {
          name: "brand",
          required: true,
          label: "Brand",
          align: "center",
          field: "brand",
        },
        {
          name: "recent_price",
          required: true,
          label: "Today's Selling Price",
          align: "center",
          field: "recent_price",
        },
        {
          name: "selling_price",
          required: true,
          label: "Predicted Selling Price for tomorrow",
          align: "center",
          field: "selling_price",
        },
        
      
      ],
      columns8: [
        {
          name: "product_name",
          required: true,
          label: "Product Name",
          align: "center",
          field: "product_name",
        },
        {
          name: "gross_price",
          required: true,
          label: "Gross Price",
          align: "center",
          field: "gross_price",
        },
        {
          name: "total_unit",
          required: true,
          label: "Total Unit",
          align: "center",
          field: "total_unit",
        },
        {
          name: "unit_name",
          required: true,
          label: "Unit Name",
          align: "center",
          field: "unit_name",
        },
         {
          name: "per_unit_price",
          required: true,
          label: "Price per unit",
          align: "center",
          field: "per_unit_price",
        },
        
      ],
     
       columns9: [
       { 
          
          name: "title",
          required: true,
          label: "Out Of Stock Products",
          align: "center",
          field: "title",
        
        },
        
       
        
      ],
      
      
      rows8: [],
       rows9: [
        {
          title: "outofstock",
        
        },
      ],
      data: [],
    };
  },
  methods: {
    keywording(de) {
      console.log(de);
    },
    options(date) {
        return date <= this.temp_date;
      },
    
    visibleUpdate(temp){
      this.visible=temp;
    },
    async copyText(url){
      try {
      await navigator.clipboard.writeText(url);
      this.$alert('Product link has been copied');
    } catch($e) {
      this.$alert('Cannot copy product link');
    }
      },
  
    redirect(url){
    
      console.log(url);
      window.location.href = "http://"+url;
    },
    
    get_label(details) {
      this.product_label = details["product_name"];
      this.analytic_detail = details;
      return details;
    },
    get_analysis(details) {
      this.$mixpanel.track('pricetracker/Analytics/Show Analysis',{
        info: 'User tracked Show Analysis'
      })
      if(this.product_label == "Select Product" ){
        this.$alert("Please select a product");
      }
      else{
      this.$q.loading.show({
      message: "Loading data please wait..",
      
    });
      
      console.log("details",details);
     
      this.exp = false;
      this.expanded = false;
  
  
      this.expanded1 = false;
      this.expanded2 = false;
      this.expanded3 = false;
      this.expanded4 = false;
      this.expanded5 = false;
      this.expanded6 = false;
      this.expanded7 = false;
      this.expanded8 = false;
      this.visible = false;
         this.analysis.length = 0;
      this.toprank=false;
    
       this.noOutofStock= false;
      this.daily_analysis.length = 0;
      this.pricewatch_graph_url="";
      
      
      
           this.analysis = [];
           this.rows8 = [];
         
           this.rows2 = [];
           this.rows4=[
            {rank:'',
            rank7:'',
            rank30:'',
            rank90:''},
            {rank:'',
            rank7:'',
            rank30:'',
            rank90:''},
            
            {rank:'',
            rank7:'',
            rank30:'',
            rank90:''},
            {rank:'',
            rank7:'',
            rank30:'',
            rank90:''},
            
          ];
        
           this.date='date';
           this.daily_analysis = [];
       this.analysis=[],
         
         
           this.rows5=[];
         
           this.rows6[0].product_name='';
           this.rows6[0].text_insights='';
          
           this.prediction_details='';
          
      var count=0;
      var count1=0;
      var temporary_date = this.today_date.replaceAll("/","-");
      var productsURL = this.api_url + "/products/price_watch_get_analysis/"+temporary_date;
      this.$http
        .post(productsURL, [details])
        .then((response) => {
          
          let result = response.data;
          console.log(result);                                      
          let data = result.map((items) => {
            return {
              ...items,
              // input: items.compare_at_price ? items.compare_at_price : 0,
            };
          });
          console.log(data);
          this.analysis = data;
          this.rows8 = data[0]['unit_price'];
          // console.log("analysis" + this.analysis);
          console.log(data);
          this.rows2 = data[0]["competitors_details"]["competitors_dtls"];
          console.log("rows2");
          console.log(this.rows2);
          this.date=data[0]["datetime"].split("T")[0];
          console.log("date");
           console.log(data[0]["datetime"].split("T"));
         
          // this.backupList = data;
          // this.isLoading = false;
          if(count==2)
          {
             this.$q.loading.hide();
            this.$alert('Your data is loaded, please check');
            
          }
          else
          {
            
            count++;
          }
          
        })
        .catch((err) => {
          
          
          this.isLoading = false;
          //console.log(err);
          
          
          if(count1==1)
          {
             this.toprank=true;
            this.$alert('Both Weekly analysis and Daily analysis data of the selected product is not available for the selected date');
          }
          else 
          {
            this.$q.loading.hide();
            this.$alert('Weekly analysis of the selected product is not available for the chosen date.');
            count1++;
          }
        });
 
         var rankingsURL = this.api_url + "/products/price_watch_get_daily_analysis/"+temporary_date;
         this.$http
        .post(rankingsURL,  [details])
        .then((response) => {
          
          let result = response.data;
          console.log(result);                                      
          let data = result.map((items) => {
            return {
              ...items,
              // input: items.compare_at_price ? items.compare_at_price : 0,
            };
          });
          console.log(data);
          this.daily_analysis = data;
          // console.log("analysis" + this.analysis);
          console.log(data);
          //this.rows4=this.daily_analysis[0]["rank_details"];
          this.max_length= this.daily_analysis[0]["rank_details"].length;
         
          for (let i = 0; i < this.daily_analysis[0]["rank_details"].length; i++) {
            this.rows4[i].rank= this.daily_analysis[0]["rank_details"][i].category + ", " +this.daily_analysis[0]["rank_details"][i].rank;
          } 
          console.log(this.rows4);
          this.rows5=this.daily_analysis[0]["best_seller_details"];
          console.log("best sellers"); 
          console.log(this.daily_analysis[0]["best_seller_details"]); 
        
          console.log("rows6");
          console.log(this.rows6);
          this.rows6[0].product_name=this.daily_analysis[0]["product_name"];
          this.rows6[0].text_insights=this.daily_analysis[0]["text_insight"];
          
          console.log("prediction_details");
          console.log(this.daily_analysis[0]["prediction_details"]);
          this.prediction_details=this.daily_analysis[0]["prediction_details"];
          
          // this.backupList = data;
          // this.isLoading = false;
          if(count==2)
          {
             this.$q.loading.hide();
            this.$alert('Your data is loaded, please check');
          }
          else
          {
           
            count++;
          }
        })
        .catch((err) => {
        
          this.isLoading = false;
          //console.log(err);
          if(count1==1)
          {
            this.$alert('Both Weekly analysis and Daily analysis data of the selected product is not available for the selected date');
          }
          else 
          {
             this.expanded = true;
             this.toprank=true;
            this.$q.loading.hide();
            this.$alert('Daily analysis of the selected product is not available for the chosen date.');
            count1++;
          }
        });
        var rankingURL = this.api_url + "/products/price_watch_get_rank/"+ temporary_date;
         this.$http
        .post(rankingURL,  [details])
        .then((response) => {
          let result = response.data;
          console.log(result);                                      
          
          
          this.rankings = result;
          // console.log("analysis" + this.analysis);
          console.log("rankings",result["rank_details"]);
          
          this.max_length=Math.max(this.max_length,this.rankings["rank_details"][0].length);
          
         
          for (let i = 0; i < this.rankings["rank_details"][0].length; i++)
          {
              this.rows4[i].rank7= this.rankings["rank_details"][0][i].category + ", " +this.rankings["rank_details"][0][i].rank;
          }
          this.max_length=Math.max(this.max_length,this.rankings["rank_details"][1].length);
          
          for (let i = 0; i < this.rankings["rank_details"][1].length; i++)
          {
              this.rows4[i].rank30= this.rankings["rank_details"][1][i].category + ", " +this.rankings["rank_details"][1][i].rank;
          }
          this.max_length=Math.max(this.max_length,this.rankings["rank_details"][2].length);
          for (let i = 0; i < this.rankings["rank_details"][2].length; i++)
          {
              this.rows4[i].rank90= this.rankings["rank_details"][2][i].category + ", " +this.rankings["rank_details"][2][i].rank;
          }
          this.rows4.length = this.max_length;
          if(this.rankings["rank_details"][0].length == 1 && this.rankings["rank_details"][0][0].category =="Not available")
          {
            for (let i = 0; i < this.rows4.length; i++)
          {
              this.rows4[i].rank7= "NA";
          }
          }
            if(this.rankings["rank_details"][1].length == 1 && this.rankings["rank_details"][1][0].category =="Not available")
          {
            for (let i = 0; i < this.rows4.length; i++)
          {
              this.rows4[i].rank30= "NA";
          }
          }
            if(this.rankings["rank_details"][2].length == 1 && this.rankings["rank_details"][2][0].category =="Not available")
          {
            for (let i = 0; i < this.rows4.length; i++)
          {
              this.rows4[i].rank90= "NA";
          }
          }
           
           if(this.analysis[0]['competitors_details']['unavailable_product'].length == 0){
            this.noOutofStock = true;
             
           }
           else{
             this.noOutofStock = false;
           }
               
        // var rankingURL = this.api_url + "/products/price_watch_get_rank/"+ temporary_date;
        //  this.$http
        // .post(rankingURL,  [details])
        // .then((response) => {
        //   let result = response.data;
        //   console.log(result);                                      
        //   let data = result.map((items) => {
        //     return {
        //       ...items,
        //       // input: items.compare_at_price ? items.compare_at_price : 0,
        //     };
        //   });
          
        //   this.rankings = data;
        // console.log("analysis")
          // console.log("analysis" + this.analysis);
        //   console.log(data);
          
        //   //this.rows4=this.daily_analysis[0]["rank_details"];
        //     if(this.rankings.length>0)
        //     {
        //       this.max_length=Math.max(this.max_length,this.rankings[0]["rank_details"].length);
        //     for (let i = 0; i < this.rankings[0]["rank_details"].length; i++)
        //     {
        //         this.rows4[i].rank7= this.rankings[0]["rank_details"][i].category + ", " +this.rankings[0]["rank_details"][i].rank;
        //     } 
        //     }
        //     if(this.rankings.length>1)
        //     {
        //       this.max_length=Math.max(this.max_length,this.rankings[1]["rank_details"].length);
        //     for (let i = 0; i < this.rankings[1]["rank_details"].length; i++)
        //     {
        //         this.rows4[i].rank30= this.rankings[1]["rank_details"][i].category + ", " +this.rankings[1]["rank_details"][i].rank;
        //     } 
        //     }
        //     if(this.rankings.length>2)
        //     {this.max_length=Math.max(this.max_length,this.rankings[2]["rank_details"].length);
        //     for (let i = 0; i < this.rankings[2]["rank_details"].length; i++)
        //     {
        //         this.rows4[i].rank90= this.rankings[2]["rank_details"][i].category + ", " +this.rankings[2]["rank_details"][i].rank;
        //     } 
        //     }
        //     this.rows4.length = this.max_length;
          
          
          console.log(this.rows4);
          
          if(count==2)
          {
            this.expanded = true;
             this.$q.loading.hide();
             
            this.$alert('Your data is loaded, please check');
            
          }
          else
          {
           
            count++;
          }
         
          // this.backupList = data;
          // this.isLoading = false;
        })
        .catch((err) => {
          this.$q.notify({
            message: "There is no rank details data for selected item",
            color: "negative",
          });
          this.isLoading = false;
          //console.log(err);
        });
   
    var resultshistoryURL = this.api_url + "/resultshistory/pricewatch_user_request/"+details['req_id'];
     
    this.$http
      .get(resultshistoryURL)
      .then((response) => {
        let result = response.data;
        // console.log(response.data);
        let data = result.map((items) => {
          return {
            ...items,
            //jobnum: count++
          };
        });
        console.log(data);
        this.user_request=data;
          
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        // console.log(err);
      });
    }},
    get_priceinsights_dashboard_id(details) {
      this.visible=!this.visible;
      
      var getURL = this.api_url + "/quicksight/get_pricechange_dashboard_id/" + details['req_id'] ;
       this.$http
      .get(getURL)
      .then((response) => {
        let result = response;
        console.log(result)
        this.dash_board_id = response.data;
        // let data = result.map((items) => {
        //   return {
        //     ...items,
        //     // input: items.compare_at_price ? items.compare_at_price : 0,
        //   };
        // });
        console.log(response.data);
        this.get_priceinsights_graph();
        
        
        // console.log("analysis" + this.analysis);
        // console.log(data);
        // this.backupList = data;
        // this.isLoading = false;
      })
      .catch((err) => {
        this.$q.notify({
          message: "Please Select Product first",
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
      
      
    },
    get_priceinsights_graph() {
       var getURL = this.api_url + "/quicksight/get_embed_url/" + this.dash_board_id ;
       this.$http
      .get(getURL)
      .then((response) => {
        let result = response;
        console.log(result)
        this.pricewatch_graph_url = response.data;
        // let data = result.map((items) => {
        //   return {
        //     ...items,
        //     // input: items.compare_at_price ? items.compare_at_price : 0,
        //   };
        // });
        console.log(response.data);
        
        
        // console.log("analysis" + this.analysis);
        // console.log(data);
        // this.backupList = data;
        // this.isLoading = false;
        
      })
      .catch((err) => {
        this.$q.notify({
          message: "Please Select Product first",
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
    }
    
  },
  mounted() {
     
     this.$q.loading.show({
       message: "Authenticating please wait..",
     });
      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$store.dispatch("setPathName", "/pricewatch/analytics");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$store.dispatch("setPathName", "/pricewatch/analytics");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$store.dispatch("setPathName", "/pricewatch/analytics");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
    var productsURL = this.api_url + "/resultshistory/pricewatchanalytics/" + this.$org_id.label;
    this.$http
      .get(productsURL)
      .then((response) => {
        let result = response.data;
        console.log(result);
        let data = result.map((items) => {
          return {
            ...items,
            // input: items.compare_at_price ? items.compare_at_price : 0,
          };
        });
        console.log("data");
        console.log(data);
        this.data = data;
        console.log(data);
        this.backupList = data;
        this.isLoading = false;
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
      var date = new Date();
      var dd = String(date.getDate()).padStart(2, '0');
      var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date.getFullYear();
      this.today_date = yyyy + '/' + mm + '/' + dd;
      this.temp_date = this.today_date;

      var productsURL = this.api_url + "/products/price_watch_analytics_products/" + this.$org_id.label;
    this.$http
      .get(productsURL)
      .then((response) => {
        let result = response.data;
        console.log(result);
        let data = result.map((items) => {
          return {
            ...items,
            // input: items.compare_at_price ? items.compare_at_price : 0,
          };
        });
        
        console.log(data);
        this.products = data;
        console.log(data);
        // this.backupList = data;
        // this.isLoading = false;
        this.$q.loading.hide();
      })
      .catch((err) => {
        this.$q.loading.hide();
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
  },
};
</script>


    
   


 



<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.whole{
  height:100%;
  width:100%;
  align-items:center;
  justify-content: center;
  display: flex;
font-family: "Montserrat", sans-serif;
  
 
 
  
}
.keyword{
  border:none;
  box-shadow: none !important ;
}
.main-parent{
  height: 674px;
  width: 1255px;
  background-color:white;
 
}
.info{
  height:100%;
}
.details{
  height:100%;
}
.secondtab{
    background-color: #F4F7FC;
    font-weight: bold;
    box-shadow: none !important;
    
}
#second  .row{
 margin-top:0px !important;
}
.greencolor{
  height: 100%;
 width: 10px;
  background-color: #37833B!important;
}
 .q-tab-panel {
    padding: 0px !important;
    margin-top:16px;
    
}
.tab-1{
  padding-left:5px;
 
  font-size:12px;
}
 
  .q-card{
    box-shadow: none !important ;
    border-radius: 0px;
    vertical-align: top;
    background: #fff;
    position: relative;
}
.wp-block-ub-tabbed-content-tabs-content{
  border:0;
}
.date{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 1px 5px px #00000026;
opacity: 1;
}
.dpdn {
 
    
    height:43px !important;
    width:700px;
   
    border: 2px solid #00000026;
   
border-radius: 10px;
opacity: 1;
font-size:13px;
   
   
  
  
   
   
   
}
.dropbox{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 5px 30px #00000026;
border-radius: 10px;
opacity: 1;
}
 
.hhh{
  height:10px;
  width:20px;
}
.button-1{
  border:none;
}
#secondtab .q-tabs {
  
    border-radius: 10px!important;
     height: 100%;
}
.firsttab{
font-weight:bold;
text-align: left;
}
.tabs{
  height: 100px;
}
.ranktab{
   background-color: #102689;
    color:white;
    font-weight: bold;
   
   
   
   
}
.priceinsightbutton{
  color: white;
  background-color: #102689;
}
#content{
  
  background-color: pink;
}
.yourprice{
  background-color: #102689;
  text-align: center;
  padding: 10px 25px 10px 25px;
  height: fit-content;
  width: fit-content;
  color: #fff;
  
  border-radius: 10px;
}
 #outofbox .q-table__card {
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 20px #00000029 !important;
border-radius: 23px !important;
margin-bottom: 50px;
}
.q-table__card {
   
    border-radius: 0px !important;
    box-shadow:none !important;
}
.q-virtual-scroll__padding {
   
    background-size:0px !important;
   
}
.q-virtual-scroll__content {
    border: 1px solid #000 !important;
}
.rule{
  padding:0px 20px 1000px 20px;
  height: 90px;width:482px ;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 20px #00000029;
border-radius: 15px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.box{
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
 
  
}
.rule{
  width:100%;
  margin-right:5px;
}
.text-icon{
  color:#707070 !important;
}
.text-firsttabactive{
  color:#11141A !important;
}
.text-nonactive{
  color:#BBC5D5!important;
}
.text-activecolor{
  color: #102689 !important;
}
 .bg-activecolor {
  background-color: #a2aa33 !important;
}
ul.checkmark li {
  list-style-type: none;
  padding: 0.25em 0 0 3.25em;
  position: relative;
  font-size: 16px;
}
ul.checkmark li::before {
  content: " ";
  background-color:#00A88F ;
  display: block;
  border: solid 0.5em #00A88F;
  border-radius: 0.5em;
  height: 0;
  width: 0;
  position: absolute;
  left: 0.8em;
  top: 50%;
  margin-top: -0.4em;
}
ul.checkmark li:after {
  content: " ";
  display: block;
  width: 0.3em;
  height: 0.6em;
  border: solid #fff;
  border-width: 0 0.2em 0.2em 0;
  position: absolute;
  left: 1.1em;
  top: 47%;
  align-items: center;
  justify-content: center;
  margin-top: -0.1em;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.openlink{
  background-color: #29B40B;
  color: #fff;
  border-radius: 5px;
}
.toprank{ 
  max-height:450px;
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;
     &::-webkit-scrollbar {
      background: transparent; /* Chrome/Safari/Webkit */
      width: 0px;
    }
}
.priceinsight{ 
  max-height:450px;
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;
     &::-webkit-scrollbar {
      background: transparent; /* Chrome/Safari/Webkit */
      width: 0px;
    }
}
.productprice{
  background: #F1F2F6 0% 0% no-repeat padding-box;
border: 1px solid #EEEEEE;
border-radius: 2px;
padding: 5px 12px 5px 12px;
margin: 7px;
color: #0C1125;
opacity: 0.65;
font-size:12px;
}
.header1{
   height:auto;
   width:350px;
  border-radius: 20px 20px 5px 5px;
  border:2px solid #102689;
   background-color:  #102689 !important;
    color:white;
    font-weight: bold;
    
 
   
}
.header2{
  display:none;
}
.outofbox{
  
  height:400px!important;
  align-items:center;
  justify-content:center;
  display:flex;
}
#outofbox .q-table {
    width: 100%;
    max-width: 100%;
    border-collapse: separate !important;
    border-spacing: 700px !important;
}
.outofstock{
  min-height:200px;
}
.nooutofstock{
 padding-top:50px;
 color:red;
  align-items:center;
  justify-content:center;
  display:flex;
  font-size:18px;
  font-weight:600;
  margin-bottom: 200px;
}
.q-table thead tr, .q-table tbody td {
     height: 48px; 
    // /* width: 20px !important; */
}
.body1{
  align-items:left;
  display:flex;
  background:white 0% 0% no-repeat padding-box;
  margin-left: 15px;
  margin-right:15px;
 
 
}
.q-field__control {
    color:black;
    color: var(--q-color-dark);
    height: 0px;
    max-width: 100%;
    outline: none;
}
.prdct{
  margin-left: -10px;
}
.showanalysis{
  height:43px;
  width: 180px;
    background-color: #102689;
    color:white;
    border: 1px solid #707070;
border-radius: 10px;
}
.aibsd{ 
  max-height:100px;
  width:100%;
 
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;
     &::-webkit-scrollbar {
      background: transparent; /* Chrome/Safari/Webkit */
      width: 0px;
    }
}
.my-sticky-header-table{
  height:200px;
   
}
.my-sticky-header-table .q-table__top,
.my-sticky-header-table .q-table__bottom,
.my-sticky-header-table thead tr:first-child th {
  background-color:#102689 ;
}
.my-sticky-header-table thead tr th {
  position: sticky;
  z-index: 1;
  
}
.my-sticky-header-table thead tr:last-child th {
  /* height of all previous header rows */
  top: 48px;
}
.my-sticky-header-table thead tr:first-child th {
  top: 0;
}
.my-sticky-virtscroll-table {
  /* height or max-height is important */
  height: 410px;
  /* this will be the loading indicator */
}
.my-sticky-virtscroll-table .q-table__top,
.my-sticky-virtscroll-table .q-table__bottom,
.my-sticky-virtscroll-table thead tr:first-child th {
  background-color: #fff;
}
.my-sticky-virtscroll-table thead tr th {
  position: sticky;
  z-index: 1;
}
.my-sticky-virtscroll-table thead tr:last-child th {
  /* height of all previous header rows */
  top: 48px;
}
.my-sticky-virtscroll-table thead tr:first-child th {
  top: 0;
}
.q-btn__wrapper,before {
    content: "";
    display: none!important;
    position: relative!important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: none!important;
    box-shadow: none!important;
}
</style>